import { defineStore } from 'pinia'

import { stateInit } from './state'
import getters from './getters'
import actions from './actions'

export const useUser = defineStore('user', {
  state: stateInit,
  getters,
  actions
})